import initialState from '../../data/userLists';
import ActionTypes from '../constants/action-types';

const userListsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_USER_LISTS_BUSY:
            return {
                ...state,
                busy: action.payload
            };

        case ActionTypes.SET_USER_LISTS:
            return {
                ...state,
                userLists: action.payload
            };

        case ActionTypes.SET_ACTIVE_USER_LIST:
            return {
                ...state,
                activeUserList: action.payload
            };

        case ActionTypes.SET_USER_LIST_USERS_BUSY:
            return {
                ...state,
                usersBusy: action.payload
            };

        case ActionTypes.SET_USER_LIST_USERS:
            return {
                ...state,
                users: action.payload
            };

        case ActionTypes.APPEND_USER_LISTS:
            return {
                ...state,
                userLists: [...state.userLists, ...action.payload]
            };

        case ActionTypes.APPEND_USER_LIST_USERS:
            return {
                ...state,
                users: [...state.users, ...action.payload]
            };

        case ActionTypes.SET_USER_LIST_PAGE:
            return {
                ...state,
                userListsPage: action.payload
            };

        case ActionTypes.SET_USER_LIST_USER_PAGE:
            return {
                ...state,
                usersPage: action.payload
            };

        case ActionTypes.SET_USER_LISTS_HAS_MORE:
            return {
                ...state,
                userListsHasMore: action.payload
            };

        case ActionTypes.SET_USER_LISTS_TOTAL:
            return {
                ...state,
                userListsTotal: action.payload
            };

        case ActionTypes.SET_USER_LIST_USERS_TOTAL:
            return {
                ...state,
                usersTotal: action.payload
            };

        case ActionTypes.TOGGLE_USER_LIST_MODAL:
            return {
                ...state,
                userListModal: action.payload
            };

        case ActionTypes.RESET_USER_LIST_USERS:
            return {
                ...state,
                users: [],
                usersHasMore: true,
                usersPage: 1,
                usersTotal: 0
            };

        case ActionTypes.RESET_USER_LISTS:
            return {
                ...state,
                userLists: [],
                userListsHasMore: true,
                userListsPage: 1,
                userListsTotal: 0,
                activeUserList: {}
            };

        case ActionTypes.PREPEND_USER_LISTS:
            let tmpLists = [...state.userLists];
            tmpLists.unshift(action.payload);
            return {
                ...state,
                userLists: [...tmpLists]
            };

        case ActionTypes.REMOVE_USER_LIST_USER:
            let tmp = [...state.users];
            const index = tmp.findIndex(u => u.id == action.payload);

            if (index >= 0) {
                tmp.splice(index, 1);
                return {
                    ...state,
                    users: [...tmp]
                };
            }

        case ActionTypes.REMOVE_USER_LIST:
            tmp = [...state.userLists];
            let i = tmp.findIndex(u => u.id == action.payload);

            if (i >= 0) {
                tmp.splice(i, 1);
                return {
                    ...state,
                    userLists: [...tmp]
                };
            }

        case ActionTypes.UPDATE_USER_LIST:
            tmpLists = [...state.userLists];
            i = tmpLists.findIndex(l => l.id == action.payload.id);

            if (i >= 0) {
                tmpLists[i] = action.payload;
            }

            return {
                ...state,
                userLists: [...tmpLists]
            };

        default: return state;
    }
};

export default userListsReducer;
